
export default {
  name: 'configPop',
  data() {
    return {
      dialogVisible: false,
      getParams: {},
      bindGoodsList: []
    }
  },
  computed: {
    isDisabled() {
      let disabled = true
      this.bindGoodsList.map(item => {
        if (!item.isBind && this.bindGoodsList.length > 1) {
          disabled = false
        }
      })
      return disabled
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    async openDialog(data) {
      this.getParams = data
      await this.getBindConjoinedGoods()
      this.dialogVisible = true
    },
    //获取连体商品
    async getBindConjoinedGoods() {
      const res = await this.$api.unionUnBindOptionsApi({ isBind: true, ...this.getParams })
      if (!res.success) {
        return this.$message.error(res.info)
      }
      this.bindGoodsList = res.data
      // 没有商品 (按道理不会出现这种情况)
      if (this.bindGoodsList.length === 0) {
        this.onAddConjoined()
      }
      // 只有一个商品则为他自身 默认未确认
      else if (this.bindGoodsList.length === 1) {
        this.bindGoodsList[0].isBind = false
      }
    },
    //确认连体
    onConfirmConjoined() {
      if (this.isDisabled) return
      const topPriceGoods = this.bindGoodsList.sort((a, b) => a.goodsPrice - b.goodsPrice)[0]
      const topBasePriceGoods = this.bindGoodsList.sort((a, b) => a.basePrice - b.basePrice)[0]
      const topPrice = topPriceGoods.goodsPrice
      const topBasePrice = topBasePriceGoods.basePrice
      const goodsNos = this.bindGoodsList.map(item => item.goodsNo)
      const goodsUnionNo = this.getParams.goodsUnionNo
      this.$refs.priceConfirmPop.openDialog({ topPrice, topBasePrice, goodsNos, goodsUnionNo, topPriceGoods, topBasePriceGoods })
    },
    //打开解除连体确认弹窗
    onCancelConjoined(data) {
      this.$refs.cancelConfirmPop.openDialog(data)
    },
    //本地删除解绑的账号 避免直接请求覆盖未确认的商品
    onUnBindHandle(data) {
      // this.bindGoodsList.map((item,index) => {
      //     if(data.id === item.id){
      //         this.bindGoodsList.splice(index,1)
      //     }
      // })
      this.getBindConjoinedGoods()
    },
    //添加连体账号
    onAddConjoined() {
      this.$refs.choosePop.openDialog({ isBind: false, ...this.getParams })
    },
    //设置已选择未确认的商品
    setChooseGoods(data) {
      const ids = this.bindGoodsList.map(item => item.goodsNo)
      if (!ids.includes(data.goodsNo)) {
        this.bindGoodsList.push({ isBind: false, ...data })
      }
    }
  },
  mounted() { }
}
